import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Registrar Service Worker para PWA
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('✅ PWA: App pronto para uso offline!');
  },
  onUpdate: (registration) => {
    console.log('🔄 PWA: Nova versão disponível!');
    // Mostrar notificação de atualização
    if (window.confirm('Nova versão disponível! Deseja atualizar agora?')) {
      registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  }
});

